import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import toast from "react-hot-toast";
import Box from '../../components/Box';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import RefreshButton from '../../components/RefreshButton';
import ColumnChooser from '../../components/ColumnChooser';
import TableConstantActions from '../../components/TableConstantActions';
import CustomDatePicker from '../../components/CustomDatePicker';
import CustomTextInput from '../../components/CustomTextInput';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../components/CustomSingleSelect';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import { kolonlariBirlestir } from '../../components/ColumnFilter/kolonBirlestir';
import ColumnFilterRow from '../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, foldText } from '../../components/ColumnFilter/ColumnFilterTypes';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { PersonnelService } from '../../services/PersonnelService';
import { IZIN_BEKLIYOR, IzinBakiyeItem, IzinItem, IzinService, IzinTuruItem, izinDurumSinifi } from '../../services/IzinService';

/** Ekranda süzme / sıralama için satırın kolon değeri. */
const kolonDegeri = (x: IzinItem, kolon: string): string => {
    switch (kolon) {
        case 'personelAdi': return x.personelAdi ?? '';
        case 'kod': return x.izinTuruId;
        case 'turAdi': return x.turAdi;
        case 'baslangic': return x.baslangic;
        case 'bitis': return x.bitis;
        case 'gunSayisi': return String(x.gunSayisi).padStart(4, '0');
        case 'ucretli': return x.ucretli ? '1' : '0';
        case 'aciklama': return x.aciklama ?? '';
        case 'giren': return x.giren ?? '';
        case 'durum': return String(x.durum);
        case 'dusenGun': return x.dusenGun == null ? '' : String(x.dusenGun).padStart(4, '0');
        case 'karar': return x.kararVeren ?? '';
        default: return '';
    }
}

interface EkranFiltresi {
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
}

/**
 * İzin Kayıtları (İnsan Kaynakları, 03.11.2026). İK girer; izinli günde mesai hatırlatması gitmez, ek mesai talebinde
 * kişi seçilemez, puantajda izin kodu (Yİ, R ...) yazar. Liste tarih aralığına göre gelir; kolon filtresi ekranda uygulanır.
 */
const IzinList = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > İzin Kayıtları"
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const formRef = useRef<any>(null);

    const [aralikBas, setAralikBas] = useState<string>(moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'));
    const [aralikBit, setAralikBit] = useState<string>(moment().add(2, 'month').endOf('month').format('YYYY-MM-DD'));
    const [liste, setListe] = useState<IzinItem[]>([]);
    const [turler, setTurler] = useState<IzinTuruItem[]>([]);
    // Zilden gelince (bekleyen izin istekleri) süzgeç hazır gelir.
    const location = useLocation();
    const [filter, setFilter] = useState<EkranFiltresi>({ sortColumn: 'baslangic', sortDirection: 'desc', columnFilters: (location.state as any)?.columnFilters ?? [] });

    const [isOpen, setIsOpen] = useState(false);
    const [duzenlenenId, setDuzenlenenId] = useState<string | undefined>(undefined);
    const [personel, setPersonel] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [tur, setTur] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [bas, setBas] = useState<string | undefined>(undefined);
    const [bit, setBit] = useState<string | undefined>(undefined);
    const [aciklama, setAciklama] = useState<string | undefined>(undefined);
    const [sekme, setSekme] = useState<'kayit' | 'bakiye'>('kayit');
    const [bakiyeler, setBakiyeler] = useState<IzinBakiyeItem[]>([]);
    const [reddedilen, setReddedilen] = useState<IzinItem | undefined>(undefined);
    const [redNedeni, setRedNedeni] = useState<string | undefined>(undefined);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Personel', name: 'personelAdi', order: 0, isVisible: true },
            { title: 'Kod', name: 'kod', order: 0, isVisible: true },
            { title: 'İzin Türü', name: 'turAdi', order: 0, isVisible: true },
            { title: 'Başlangıç', name: 'baslangic', order: 0, isVisible: true },
            { title: 'Bitiş', name: 'bitis', order: 0, isVisible: true },
            { title: 'Gün', name: 'gunSayisi', order: 0, isVisible: true },
            { title: 'Ücretli', name: 'ucretli', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'aciklama', order: 0, isVisible: true },
            { title: 'Giren', name: 'giren', order: 0, isVisible: true },
            { title: 'Durum', name: 'durum', order: 0, isVisible: true },
            { title: 'Yıllık İzinden Düşen', name: 'dusenGun', order: 0, isVisible: true },
            { title: 'Karar', name: 'karar', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
        getTurler();
    }, [])

    useEffect(() => {
        getData();
    }, [aralikBas, aralikBit])

    const getTurler = async () => {
        try {
            var response = await IzinService.turListesi();
            if (response.isSuccess)
                setTurler(response.data ?? []);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const getData = async () => {
        if (!aralikBas || !aralikBit)
            return;

        try {
            dispatch(storeActivityIndicator(true));
            var response = await IzinService.liste(aralikBas, aralikBit);

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            setListe((response.data ?? []).map(x => ({ ...x, isSelected: false })));

            var b = await IzinService.bakiyeler();
            if (b.isSuccess)
                setBakiyeler(b.data ?? []);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    /** Mobilden gelen isteğe karar (onay ya da neden yazılarak red). */
    const karar = async (item: IzinItem, onay: boolean) => {
        try {
            if (!onay && (!redNedeni || redNedeni.trim() == '')) {
                toast.error("Red nedenini yazınız.");
                return;
            }
            dispatch(storeActivityIndicator(true));
            var response = await IzinService.karar(item.izinId, onay, onay ? null : redNedeni!.trim());
            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }
            toast.success(onay ? "İzin onaylandı; personele bildirim gitti." : "İzin reddedildi; personele bildirim gitti.");
            setReddedilen(undefined);
            setRedNedeni(undefined);
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const gorunen = liste.filter(x => (filter.columnFilters ?? []).every(f => {
        if (f.values && f.values.length > 0)
            return f.values.includes(kolonDegeri(x, f.column));

        if (f.text && f.text.trim())
            return foldText(kolonDegeri(x, f.column)).includes(foldText(f.text.trim()));

        if (f.from || f.to) {
            var d = kolonDegeri(x, f.column);
            return (!f.from || d >= f.from) && (!f.to || d <= f.to);
        }

        return true;
    })).sort((a, b) => {
        if (!filter.sortColumn)
            return 0;

        var r = kolonDegeri(a, filter.sortColumn).localeCompare(kolonDegeri(b, filter.sortColumn), 'tr');
        return filter.sortDirection == 'desc' ? -r : r;
    });

    const sortableColumns = ['personelAdi', 'kod', 'turAdi', 'baslangic', 'bitis', 'gunSayisi', 'ucretli', 'giren', 'durum', 'dusenGun'];
    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, (f?: EkranFiltresi) => { if (f) setFilter(f); });

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        personelAdi: { type: 'text' },
        kod: { type: 'select', loadOptions: () => Promise.resolve(turler.map(x => ({ value: x.izinTuruId, label: `${x.kod} · ${x.ad}` }))) },
        turAdi: { type: 'text' },
        baslangic: { type: 'date' },
        bitis: { type: 'date' },
        ucretli: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve([{ value: '1', label: 'Evet' }, { value: '0', label: 'Hayır' }]) },
        aciklama: { type: 'text' },
        giren: { type: 'text' },
        durum: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve([{ value: '1', label: 'Onaylı' }, { value: '2', label: 'Onay bekliyor' }, { value: '3', label: 'Reddedildi' }, { value: '4', label: 'İptal edildi' }]) },
        karar: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => setFilter({ ...filter, columnFilters });

    const setItemSelected = (_id: string) => setListe(liste.map(x => x.izinId == _id ? { ...x, isSelected: !x.isSelected } : x));

    const selectAll = () => {
        var ids = gorunen.map(x => x.izinId);
        var isAllSelected = gorunen.length > 0 && gorunen.every(x => x.isSelected);
        setListe(liste.map(x => ids.includes(x.izinId) ? { ...x, isSelected: !isAllSelected } : x));
    }

    const secililer = liste.filter(x => x.isSelected);

    const scrollTo = () => setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);

    const turSecenegi = (t: IzinTuruItem): CustomSingleSelectModel => ({ label: `${t.kod} · ${t.ad}`, value: t.izinTuruId });

    const formuDoldur = (o: IzinItem | undefined) => {
        setDuzenlenenId(o?.izinId);
        setPersonel(o ? { label: o.personelAdi ?? '', value: o.personnelId } : undefined);
        setTur(o ? { label: `${o.kod} · ${o.turAdi}`, value: o.izinTuruId } : undefined);
        setBas(o?.baslangic?.substring(0, 10));
        setBit(o?.bitis?.substring(0, 10));
        setAciklama(o?.aciklama ?? undefined);
    }

    const yeniEkle = () => { formuDoldur(undefined); setIsOpen(true); scrollTo(); }
    const iptalEt = () => { formuDoldur(undefined); setIsOpen(false); }

    const ac = (o: IzinItem | undefined) => {
        if (!o || !menu?.canUpdate)
            return;
        formuDoldur(o);
        setIsOpen(true);
        scrollTo();
    }

    const personelSecenekleri = async () => {
        var response = await PersonnelService.getPersonnelList(undefined, true);
        return {
            isSuccess: response.isSuccess,
            data: (response.data ?? []).map((x: any) => ({ label: x.nameSurname, value: x.personnelId }))
        };
    }

    const kaydet = async () => {
        try {
            if (!personel?.value) { toast.error("Personel alanı zorunludur."); return; }
            if (!tur?.value) { toast.error("İzin türü alanı zorunludur."); return; }
            if (!bas || !bit) { toast.error("Başlangıç ve bitiş tarihleri zorunludur."); return; }
            if (bit < bas) { toast.error("Bitiş tarihi başlangıçtan önce olamaz."); return; }

            dispatch(storeActivityIndicator(true));

            var response = await IzinService.kaydet({
                izinId: duzenlenenId ?? null,
                personnelId: personel.value,
                izinTuruId: tur.value,
                baslangic: bas,
                bitis: bit,
                aciklama: aciklama && aciklama.trim() != '' ? aciklama.trim() : null
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("İzin kaydedildi. Bu günlerde mesai hatırlatması gitmez.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const sil = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await IzinService.sil(secililer.map(x => x.izinId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("Seçilen izinler silindi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const hucre = (item: IzinItem, column: string) => {
        var icerik: React.ReactNode;

        if (column == 'personelAdi')
            icerik = item.personelAdi;
        else if (column == 'kod')
            icerik = <span className={'badge ebbe-status-badge ' + (item.ucretli ? 'badge-light-success' : 'badge-light-danger')}>{item.kod}</span>;
        else if (column == 'turAdi')
            icerik = item.turAdi;
        else if (column == 'baslangic')
            icerik = item.baslangicStr;
        else if (column == 'bitis')
            icerik = item.bitisStr;
        else if (column == 'gunSayisi')
            icerik = item.gunSayisi;
        else if (column == 'ucretli')
            icerik = item.ucretli ? 'Evet' : 'Hayır';
        else if (column == 'aciklama')
            icerik = <span style={{ whiteSpace: 'normal' }}>{item.aciklama}</span>;
        else if (column == 'giren')
            icerik = <React.Fragment>{item.giren}<br /><span className='text-muted fs-8'>{item.tarih}</span></React.Fragment>;
        else if (column == 'durum')
            icerik = <React.Fragment>
                <span className={'badge ebbe-status-badge ' + izinDurumSinifi(item.durum)}>{item.durumAdi}</span>
                {
                    item.durum == IZIN_BEKLIYOR && menu?.canUpdate && (
                        <div className='d-flex gap-1 mt-1'>
                            <a className='btn btn-sm btn-light-success py-1 px-2' onClick={(e) => { e.stopPropagation(); karar(item, true); }}>Onayla</a>
                            <a className='btn btn-sm btn-light-danger py-1 px-2' onClick={(e) => { e.stopPropagation(); setReddedilen(item); setRedNedeni(undefined); scrollTo(); }}>Reddet</a>
                        </div>
                    )
                }
            </React.Fragment>;
        else if (column == 'dusenGun')
            icerik = item.dusenGun ?? '';
        else if (column == 'karar')
            icerik = item.kararVeren
                ? <React.Fragment>{item.kararVeren}<br /><span className='text-muted fs-8'>{item.kararZamani}</span>{item.redNedeni && <div className='text-danger fs-8' style={{ whiteSpace: 'normal' }}>{item.redNedeni}</div>}</React.Fragment>
                : '';

        return <td key={column} onClick={() => setItemSelected(item.izinId)} onDoubleClick={() => ac(item)}>{icerik}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort((a, b) => a.order - b.order);
    const toplamGun = gorunen.reduce((t, x) => t + x.gunSayisi, 0);
    const bekleyenSayisi = liste.filter(x => x.durum == IZIN_BEKLIYOR).length;

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <div className='m-0 d-flex align-items-center gap-2'>
                    <input type='date' className='form-control form-control-sm form-control-solid' style={{ width: 150 }} title='Başlangıç' value={aralikBas} onChange={(e) => setAralikBas(e.target.value)} />
                    <span className='text-muted'>–</span>
                    <input type='date' className='form-control form-control-sm form-control-solid' style={{ width: 150 }} title='Bitiş' value={aralikBit} onChange={(e) => setAralikBit(e.target.value)} />
                </div>

                <TableConstantActions
                    deleteFunction={sil}
                    onSearchSubmit={(e) => e.preventDefault()}
                    pageName={pageName}
                    hideSearch={true}
                    searchTerm=''
                    selectedCount={secililer.length}
                    setSearchTerm={() => { }}
                    updateFunction={() => ac(secililer[0])}
                />

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

                {
                    menu?.canInsert && (
                        <div className='m-0'>
                            <a onClick={yeniEkle} className='btn btn-sm fw-bold btn-primary'>Yeni İzin Ekle</a>
                        </div>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                {
                    isOpen && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-10 text-black">{duzenlenenId ? 'İzni Güncelle' : 'Yeni İzin'}</h4>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <CustomSingleSelect
                                                menuPortal
                                                labelText="Personel"
                                                isLabelRequired
                                                selectedValue={personel}
                                                onChange={setPersonel}
                                                onMenuOpen={personelSecenekleri}
                                                labelName='label'
                                                valueName='value'
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <CustomSingleSelect
                                                menuPortal
                                                labelText="İzin türü"
                                                isLabelRequired
                                                selectedValue={tur}
                                                onChange={setTur}
                                                onMenuOpen={() => Promise.resolve({ isSuccess: true, data: turler.filter(x => x.aktif).map(turSecenegi) })}
                                                labelName='label'
                                                valueName='value'
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <CustomDatePicker labelText="Başlangıç" isLabelRequired value={bas} setValue={setBas} />
                                        </div>
                                        <div className="col-md-2">
                                            <CustomDatePicker labelText="Bitiş" isLabelRequired value={bit} setValue={setBit} />
                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-md-11">
                                            <CustomTextInput labelText="Açıklama" value={aciklama} setValue={setAciklama} />
                                        </div>
                                    </div>

                                    <div className="text-muted fs-7 mt-5">
                                        İki tarih de dahildir. Bu günlerde mesai hatırlatması gitmez, kişi ek mesai talebinde seçilemez, puantajda izin kodu yazar.
                                        {' '}Aynı kişiye çakışan iki izin girilemez.
                                    </div>

                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-5">
                                        <Box mr="15px">
                                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={iptalEt}>İptal Et</button>
                                        </Box>
                                        <Box>
                                            <button className="btn btn-primary btn-sm" onClick={kaydet}>Kaydet</button>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                {
                    reddedilen && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-5 text-black">İzin isteğini reddet · {reddedilen.personelAdi} · {reddedilen.turAdi} {reddedilen.baslangicStr}–{reddedilen.bitisStr}</h4>
                                    <CustomTextInput labelText="Red nedeni" isLabelRequired value={redNedeni} setValue={setRedNedeni} />
                                    <div className="text-muted fs-7 mt-3">Neden personele bildirimle gider.</div>
                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-5">
                                        <Box mr="15px">
                                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => setReddedilen(undefined)}>Vazgeç</button>
                                        </Box>
                                        <Box>
                                            <button className="btn btn-danger btn-sm" onClick={() => karar(reddedilen, false)}>Reddet</button>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                <ul className='nav nav-tabs nav-line-tabs mb-4 fs-6'>
                    <li className='nav-item'>
                        <a className={'nav-link ' + (sekme == 'kayit' ? 'active' : '')} style={{ cursor: 'pointer' }} onClick={() => setSekme('kayit')}>
                            İzin Kayıtları {bekleyenSayisi > 0 && <span className='badge badge-light-warning ms-1'>{bekleyenSayisi} onay bekliyor</span>}
                        </a>
                    </li>
                    <li className='nav-item'>
                        <a className={'nav-link ' + (sekme == 'bakiye' ? 'active' : '')} style={{ cursor: 'pointer' }} onClick={() => setSekme('bakiye')}>Yıllık İzin Bakiyeleri</a>
                    </li>
                </ul>

                {
                    sekme == 'bakiye' && (
                        <KTCard className='mb-3'>
                            <KTCardBody className='py-2'>
                                <div className='table-responsive new-table-container'>
                                    <table className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                        <thead>
                                            <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                <th>Personel</th><th>İşe Giriş</th><th>Kıdem (yıl)</th><th>Hak Edilen</th><th>Devreden</th><th>Kullanılan</th><th>Onay Bekleyen</th><th>Kalan</th><th>Sonraki Hak</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-gray-600 fw-bold'>
                                            {bakiyeler.length == 0 && <tr><td className="text-center" colSpan={99}>Kayıt bulunamadı.</td></tr>}
                                            {
                                                bakiyeler.map(b =>
                                                    <tr key={b.personnelId}>
                                                        <td>{b.personelAdi}</td>
                                                        <td>{b.iseGirisTarihi ?? <span className='text-warning fs-8'>{b.uyari}</span>}</td>
                                                        <td>{b.iseGirisTarihi ? b.kidemYil : ''}</td>
                                                        <td>{b.iseGirisTarihi ? b.hakEdilen : ''}</td>
                                                        <td>{b.devreden || ''}</td>
                                                        <td>{b.kullanilan}</td>
                                                        <td>{b.bekleyen || ''}</td>
                                                        <td className={b.kalan < 0 ? 'text-danger' : 'text-gray-800'}>{b.kalan}</td>
                                                        <td>{b.sonrakiHakTarihi ? `${b.sonrakiHakTarihi} (+${b.yillikHak} gün)` : ''}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-muted fs-7 py-3">
                                    İş Kanunu md. 53: hizmet süresi 1–5 yıl 14 gün, 5–15 yıl 20 gün, 15 yıl ve üstü 26 gün; 18 yaş altı ve 50 yaş üstü en az 20 gün. Hak her yıl dönümünde dolar.
                                    {' '}Kullanılan: "Yıllık izinden düşer" işaretli türlerin onaylı kayıtları; hafta tatili ve resmi tatil düşmez. Kalan = devreden + hak edilen − kullanılan.
                                    {' '}İşe giriş, doğum tarihi ve devreden gün personel kartından girilir.
                                </div>
                            </KTCardBody>
                        </KTCard>
                    )
                }

                <KTCard className={'mb-3' + (sekme == 'kayit' ? '' : ' d-none')}>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips columns={columns} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={gorunen.length > 0 && gorunen.every(x => x.isSelected)} />
                                                </label>
                                            </div>
                                        </th>
                                        {gorunenKolonlar.map(item => <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>)}
                                    </tr>
                                    <ColumnFilterRow columns={gorunenKolonlar} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} leadingCellCount={1} />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        gorunen.length == 0 && (
                                            <tr><td className="text-center" colSpan={99}>Kayıt bulunamadı.</td></tr>
                                        )
                                    }
                                    {
                                        gorunen.map(item =>
                                            <tr key={item.izinId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.izinId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>
                                                {gorunenKolonlar.map(c => hucre(item, c.name))}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="text-muted fs-7 py-3">
                            {gorunen.length} kayıt · {toplamGun} gün · Seçili aralıkla kesişen izinler listelenir. İzin türleri İnsan Kaynakları › Tanımlamalar › İzin Türleri'nden yönetilir.
                            {' '}Mobilden istenen izin onaylanana kadar etkisizdir (hatırlatma, talep ve puantajı etkilemez). Web'den girilen izin doğrudan onaylıdır.
                        </div>
                    </KTCardBody>
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default IzinList;
